import React, { useState, useEffect, useRef } from "react";
import { Link, NavLink } from "react-router-dom";
import "../css/header.css";
import logo from "../images/logo.png";
import curvaTopo from "../images/curva-topo.svg";

export default function Header() {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const targetDate = new Date("2026-02-28T19:00:00");

    const countdown = setInterval(() => {
      const now = new Date();
      const diff = targetDate - now;

      if (diff <= 0) {
        clearInterval(countdown);
      } else {
        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((diff / (1000 * 60)) % 60);
        const seconds = Math.floor((diff / 1000) % 60);

        setTimeLeft({ days, hours, minutes, seconds });
      }
    }, 1000);

    return () => clearInterval(countdown);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <header className="main-header">
      <img src={curvaTopo} alt="Curva topo decorativa" className="curva-topo" />

      <div className="header-container">
        <Link to="/" className="logo">
          <img src={logo} alt="Logo" />
        </Link>

        <div className="countdown-header">
          <div className="time-segment">
            <span className="time-value">{timeLeft.days}</span>
            <span className="time-label">Dias</span>
          </div>
          <div className="time-segment">
            <span className="time-value">{timeLeft.hours}</span>
            <span className="time-label">Horas</span>
          </div>
          <div className="time-segment">
            <span className="time-value">{timeLeft.minutes}</span>
            <span className="time-label">Min</span>
          </div>
          <div className="time-segment">
            <span className="time-value">{timeLeft.seconds}</span>
            <span className="time-label">Seg</span>
          </div>
        </div>

        <button
          className="menu-toggle"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Toggle Menu"
        >
          ☰
        </button>

        <nav ref={menuRef} className={`nav-links ${isMenuOpen ? "open" : ""}`}>
          <NavLink to="/Cerimonia" onClick={() => setIsMenuOpen(false)}>
            Cerimônia
          </NavLink>
          <NavLink to="/ConfirmacaoPresencas" onClick={() => setIsMenuOpen(false)}>
            Confirmação
          </NavLink>
          <NavLink to="/ListaPresentes" onClick={() => setIsMenuOpen(false)}>
            Lista de Presentes
          </NavLink>
        </nav>
      </div>
    </header>
  );
}